import { render, staticRenderFns } from "./MultiSelectorEsporte.vue?vue&type=template&id=1f09c324&scoped=true"
import script from "./MultiSelectorEsporte.vue?vue&type=script&lang=js"
export * from "./MultiSelectorEsporte.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f09c324",
  null
  
)

export default component.exports